import { FC } from 'react';
import { Separator } from '@spikemark/ui/components/design-system/separator';
import { Check, StarIcon } from 'lucide-react';
import { PackageFeaturesProps, PricingCardProps } from './types';
import { cn } from '@spikemark/ui/utils/cn';
import { displayPrice } from '@spikemark/onboarding/utils';
import { PricingCardButton } from './pricing-card-button';
export const PackageFeatures = ({
  features,
  highlight
}: PackageFeaturesProps) => {
  const iconContainerClass = cn('p-1 border rounded-full', {
    'bg-pl-blue-500 border-pl-blue-600': highlight,
    'border-pl-gray-200': !highlight
  });
  const iconClass = cn('w-4 h-4', {
    'text-white': highlight,
    'text-pl-gray-800': !highlight
  });
  return features?.map((item, index: number) => <li key={index} className="flex gap-3 items-center mb-2.5">
      <span className={iconContainerClass}>
        <Check className={iconClass} />
      </span>
      <p className="text-pl-gray-800">{item}</p>
    </li>);
};
export const PricingCard: FC<PricingCardProps> = ({
  title,
  description,
  price,
  highlight,
  information,
  features,
  hasButton,
  handleClick,
  containerClassName = ''
}) => {
  const cardClass = cn('px-5 pt-8 pb-5 border rounded-xl bg-white flex flex-col gap-6 relative drop-shadow-sm', {
    'border-pl-blue-600 border-2': highlight,
    'border-pl-gray-200': !highlight
  }, containerClassName);
  return <div className={cardClass} data-sentry-component="PricingCard" data-sentry-source-file="pricing-card.tsx">
      {highlight && <div className="bg-pl-blue-700 rounded-md px-2.5 py-1.5 absolute -top-4 flex flex-row gap-2 items-center">
          <StarIcon className="w-4 h-4 text-white" />
          <p className="text-white text-xs">Best value</p>
        </div>}
      <div className="flex flex-col gap-3">
        <h2 className="text-2xl font-semibold">{title}</h2>
        <p className="text-base text-pl-gray-600 min-h-18">{description}</p>
      </div>
      <div className="flex flex-row gap-1">
        <p className="text-5xl font-bold">{price != null ? displayPrice(price, true) : '-'}</p>
        <div className="flex flex-col">
          <span className="font-semibold text-pl-gray-600">per team</span>
          <span className="font-semibold text-pl-gray-600">per year</span>
        </div>
      </div>

      {hasButton && <PricingCardButton title={title ?? ''} highlight={highlight} handleClick={handleClick} />}

      {information && <p className="text-base text-pl-gray-600">
          <span className="text-pl-gray-900 font-bold uppercase">New: </span>
          {information}
        </p>}

      {features && <>
          <Separator />
          <ul>
            <PackageFeatures features={features} highlight={highlight} />
          </ul>
        </>}
    </div>;
};